import {AfterViewInit, Component, inject, input, OnChanges, OnInit, output} from '@angular/core';
import {NgClass} from '@angular/common';
import {MatIconButton} from '@angular/material/button';
import {MatIcon} from '@angular/material/icon';
import {MatProgressBar} from '@angular/material/progress-bar';
import {ProcessInfoDTO} from '../../dto/process-info';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {removeAllInfoErrorMessage, removeInfoErrorMessage} from '../../services/process-info.actions';
import {Store} from '@ngrx/store';

@Component({
  selector: 'app-process-info-window',
  imports: [
    NgClass,
    MatIconButton,
    MatIcon,
    MatProgressBar,
    MatProgressSpinner
  ],
  templateUrl: './process-info-window.component.html',
  styleUrl: './process-info-window.component.scss'
})
export class ProcessInfoWindowComponent implements OnInit, OnChanges {
  private readonly store: Store = inject(Store);

  readonly process = input.required<ProcessInfoDTO>();
  readonly errorMessages = input<string[]>();
  readonly messageClosed = output<boolean>()
  isClosed = false;
  isMaximized = false;

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    this.isClosed = false;
  }

  onMinimize(): void {
    this.isMaximized = false;
  }

  onMaximize(): void {
    this.isMaximized = true;
  }

  onClose(): void {
    if (this.process().processFinished) {
      this.messageClosed.emit(true);
      if (this.errorMessages() && this.errorMessages()!.length > 0) {
        this.removeAllError();
      }
      return;
    }
    this.onMinimize();
    this.isClosed = true;
  }

  onOpen(): void {
    this.isClosed = false;
  }

  removeError(index: number) {
    this.store.dispatch(() => removeInfoErrorMessage({index}));
  }

  removeAllError() {
    this.store.dispatch(() => removeAllInfoErrorMessage());
  }
}
